import { render } from "./AlertConfigurationUpload.vue?vue&type=template&id=74af00fa"
import script from "./AlertConfigurationUpload.vue?vue&type=script&lang=js"
export * from "./AlertConfigurationUpload.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__